import { sign, verify } from 'jsonwebtoken';
import { jwtDecode } from 'jwt-decode';
import { authKeys } from '@/config/keys';

const setSession = (accessToken: string | false) => {
  if (accessToken) {
    window.localStorage.setItem(authKeys.accessToken, accessToken);
  } else {
    window.localStorage.removeItem(authKeys.accessToken);
  }
};

const checkIsTokenValid = (accessToken?: string) => {
  if (!accessToken || accessToken === 'null') {
    return false;
  }

  const expireTime = jwtDecode(accessToken).exp;
  const currentTime = Date.now() / 1000;

  return expireTime ? expireTime > currentTime + 60 * 60 * 24 : false;
};

export { setSession, checkIsTokenValid, verify, sign };
